import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogManagerService } from '@app/shared/errors/error-dialog-manager/error-dialog-manager.service';
import { Subject } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import _ from 'lodash';
import { ErrorDialogItem } from '@app/shared/errors/error-dialog-manager/error-dialog-item';

@Component({
  selector: 'app-error-dialog-manager',
  templateUrl: './error-dialog-manager.component.html',
  styleUrls: ['./error-dialog-manager.component.scss'],
  standalone: false,
})
export class ErrorDialogManagerComponent<T> implements OnInit, OnDestroy {
  public errorQueue: ErrorDialogItem[] = [];
  public currentError: ErrorDialogItem;
  private onDestroy = new Subject();

  constructor(
    public componentFactoryResolver: ComponentFactoryResolver,
    private dialog: MatDialog,
    private errorDialogService: ErrorDialogManagerService,
  ) {}

  ngOnInit(): void {
    this.errorDialogService
      .getErrors()
      .pipe(
        takeUntil(this.onDestroy),
        filter((val) => !!val),
      )
      .subscribe((error) => {
        this.errorQueue.push(error);
        if (!this.currentError) {
          this.nextErrorDialog();
        }
      });
  }

  ngOnDestroy() {
    this.onDestroy.complete();
    this.onDestroy.unsubscribe();
  }

  private nextErrorDialog() {
    if (this.currentError) {
      this.errorQueue = _.remove(this.errorQueue, (err) => this.currentError !== err);
      this.currentError = null;
    }

    if (!!this.errorQueue.length) {
      this.currentError = this.errorQueue[0];
      const dialog = this.dialog.open(this.currentError.component, {
        panelClass: 'error-dialog-container',
        data: this.currentError.data,
      });
      dialog
        .afterClosed()
        .pipe(take(1))
        .subscribe(() => {
          this.nextErrorDialog();
        });
    }
  }
}
